import { Box, HStack, Heading, SimpleGrid, Stat, StatLabel, StatNumber } from "@chakra-ui/react";

type Section = {
  title: string;
  entries: { label: string; value: number }[];
};

export default function StatsPanel({ sections }: { sections: Section[] }) {
  return (
    <HStack align="stretch" spacing={6} mb={6} wrap="wrap">
      {sections.map((s) => (
        <Box
          key={s.title}
          borderWidth="0px"
          p={4}
          minW="280px"
          flex="1 1 280px"
        >
          <Heading size="sm" mb={3} color="gray.700">
            {s.title}
          </Heading>
          <SimpleGrid columns={{ base: 2, md: 3 }} spacing={3}>
            {s.entries.map((e) => (
              <Stat key={e.label} size="sm">
                <StatLabel color="gray.600">{e.label}</StatLabel>
                <StatNumber>{e.value.toLocaleString()}</StatNumber>
              </Stat>
            ))}
          </SimpleGrid>
        </Box>
      ))}
    </HStack>
  );
}
